<template>
  <div
    v-if="order && parseInt(order.StatusId) !== OrderStatusEnum.Canceled && parseInt(order.StatusId) !== OrderStatusEnum.Completed && posUserHasComponentPermission('Orders', 'MANAGE')"
    class="d-inline-block text-no-wrap"
  >
    <v-btn
      :class="getOrderStatusButtonColorClass(order)"
      :disabled="order.loading || disabled"
      :loading="order.loading"
      :small="$vuetify.breakpoint.xsOnly"
      :style="canUpdateOrderTime ? 'min-width: 115px;' : 'min-width: 185px;'"
      class="white--text elevation-2 mx-1 px-0 d-inline-flex"
      @click.native.stop="parseInt(order.StatusId) === 0 ? null : $set(order, 'loading', true)"
      @click.exact="parseInt(order.StatusId) === 0 ? showAcceptOrderDialog(order) : updateOrderStatus(order)"
    >
      <span style="font-size: 12px;">{{ getOrderStatusNextLang(order).toLocaleUpperCase($i18n.locale) }}</span>
    </v-btn>

    <v-btn
      v-if="canUpdateOrderTime"
      :class="getOrderStatusButtonColorClass(order)"
      :disabled="order.loading || order.disabled || disabled"
      :small="$vuetify.breakpoint.xsOnly"
      class="white--text elevation-2 ml-0 mr-1 px-1 d-inline-flex"
      color="orange"
      style="min-width: 67px;"
      @click="showSelectOrderTypeTimeDialog(order)"
    >
      <v-icon size="20">
        timer
      </v-icon>

      <span
        class="mx-1 text-lowercase"
        style="font-size: 12px;"
      >
        {{ convertMinutesToDisplayString(order.OrderTypeTime) }}
      </span>
    </v-btn>
  </div>
</template>

<script>

import OrderStatus from '@/mixins/orders/orderStatus'
import OrderStatusEnum from '@/api/Enums/OrderStatusEnum.js'
import PinManagerEnum from '@/api/Enums/PinManagerEnum.js'
import OrderTypeTime from '@/mixins/orders/orderTypeTime.js'

export default {
  name      : 'OrderStatusActions',
  components: {},
  directives: {},
  mixins    : [OrderStatus, OrderTypeTime],
  props     : {
    order: {
      type   : Object,
      default: undefined
    },
    canUpdateOrderTime: {
      type   : Boolean,
      default: false
    },
    disabled: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    OrderStatusEnum() {
      return OrderStatusEnum
    }


  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    showAcceptOrderDialog(order) {
      this.$bus.$emit('show-order-accept-dialog', order)
    },

    updateOrderStatus(order) {
      this.$bus.$emit(window.SocketCommand.Order.UpdateStatus, order)
    },

    showSelectOrderTypeTimeDialog(order) {
      if (parseInt(order.StatusId) === OrderStatusEnum.Received) {
        this.executeWithPinPermissionManager(PinManagerEnum.PosChangeOrderTimeDuringAccept, (success) => {
          if (!success) return
          this.$bus.$emit('order-type-time-dialog', order)
        })
      } else {
        this.executeWithPinPermissionManager(PinManagerEnum.PosChangeOrderTimeAfterAccept, (success) => {
          if (!success) return
          this.$bus.$emit('order-type-time-dialog', order)
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
